import { useContext } from "react";
import {SnackbarContext} from "src/contexts/SnackbarContext";

const useSnackbar = () => useContext(SnackbarContext);

export default useSnackbar;
